import axios from 'axios';

axios.defaults.withCredentials = true;

export async function sendPassRecovererMail(data) {
  try {

    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}send-pass-recover-mail`,
      { email: data }
    );

    return response.data;

  } catch (error) {
    console.error('Error al enviar mail', error);
  }
}